<div class="fh-page-wrapper">
  <header class="fh-header header bottom-border-divider">
    <app-backbuttontemplate></app-backbuttontemplate>
    <h1 class="title">Last seen settings</h1>
  </header>

  <main class="fh-main content">
    <p>
      You have the option to decide whether you want your profile to display the
      last time you were online or not. However, other users can still see
      whether you are online or offline.
    </p>

    <div class="below-text-wrapper">
      @if (showLastSeen_Det) {
        <div>
          <mat-slide-toggle
            (change)="update()"
            [(ngModel)]="showLastSeen"
            name="action"
            class="slide-toggle"
            >Show last seen</mat-slide-toggle
          >
        </div>
      }

      @if (!showLastSeen_Det) {
        <div>
          <span class="loading-text">Loading...</span>
        </div>
      }
    </div>
  </main>
</div>
